import React, { useEffect } from "react";
import "./Navbar.css";
import { Link, useLocation } from "react-router-dom";
import logo from "./logo.png";

const Navbar = ({isHome}) => {
  const location = useLocation();
  const path = location.pathname;

  const linkStyle = {
    Home: {
      color: path === '/' ? '#ea363e' : '',
      fontWeight: path === '/' ? '900' : '',
    },
    Aboutpage: {
      color: path === '/Aboutpage' ? '#ea363e' : '',
      fontWeight: path === '/Aboutpage' ? '900' : '',
    },
    Services: {
      color: path === '/Services' ? '#ea363e' : '',
      fontWeight: path === '/Services' ? '900' : '',
    },
    Why: {
      color: path === '/Why' ? '#ea363e' : '',
      fontWeight: path === '/Why' ? '900' : '',
    },
    Find: {
      color: path === '/Find' ? '#ea363e' : '',
      fontWeight: path === '/Find' ? '900' : '',
    },
    Contact: {
      color: path === '/Contact' ? '#ea363e' : '',
      fontWeight: path === '/Contact' ? '900' : '',
    }
  };

  // Function to collapse the navbar on link click
  const handleLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('#navbarNav');
    if (navbarToggler && navbarCollapse.classList.contains('show')) {
      navbarToggler.click(); 
    }
  };

  // Scroll to section when hash changes in URL
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash]);

  return (
    <>
      <nav className={`navbar sticky-top navbar-expand-lg  ${isHome ? 'transparent' : 'black-background'}`} >
        <div className="container-fluid ">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="logo-img" /><br />
            <span className="logo-name" style={{ fontWeight: "900" }}>PROPERTY92.PK</span>
          </Link>
          <button style={{border:"2px solid white"}}
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          > 
            <span className="navbar-toggler-icon " ></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav gap-lg-4 gap-3 gap-xl-5">
              <li className="nav-item ">
                <Link
                  className="nav-link"
                  aria-current="page"
                  to="/"
                  style={linkStyle.Home}
                  onClick={handleLinkClick}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/Aboutpage"
                  style={linkStyle.Aboutpage}
                  onClick={handleLinkClick}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/Services"
                  style={linkStyle.Services}
                  onClick={handleLinkClick}
                >
                  Our Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/Why"
                  style={linkStyle.Why}
                  onClick={handleLinkClick}
                >
                 Why Property92.pk
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/Find"
                  style={linkStyle.Find}
                  onClick={handleLinkClick}
                >
                 Find Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/Contact"
                  style={linkStyle.Contact}
                  onClick={handleLinkClick}
                >
                  Contact Us
                </Link>
              </li>
             
             
              <li className="nav-item">
                <a
                  className="nav-link"
                  target="blank"
                  href="https://www.facebook.com/www.property92.pk/"
                  onClick={handleLinkClick}
                >
                  Today Updates
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
